import React from "react";
export const useSyncStates = (externalState, onExternalStateChange, validate) => {
    const [internalState, setInternalState] = React.useState(externalState);
    const [error, setError] = React.useState(validate?.(externalState));
    const state = React.useRef({
        externalState,
        internalState,
        onExternalStateChange,
        validate,
        error,
    });
    state.current = {
        externalState,
        internalState,
        onExternalStateChange,
        validate,
        error,
    };
    // change from outside
    React.useEffect(() => {
        if (state.current.internalState !== externalState) {
            setError(state.current.validate?.(externalState));
            setInternalState(externalState);
        }
    }, [externalState]);
    // propagate to outside
    React.useEffect(() => {
        if (state.current.externalState !== internalState) {
            const error = state.current.validate?.(internalState);
            setError(error);
            if (!error) {
                state.current.onExternalStateChange(internalState);
            }
        }
    }, [internalState]);
    return [internalState, setInternalState, error];
};
//# sourceMappingURL=useSyncStates.js.map